module.exports = __webpack_public_path__ + "static/media/popup(230829).19cf1cea.jpg";